import { render, staticRenderFns } from "./En_talent.vue?vue&type=template&id=53eb53fe&scoped=true"
import script from "./En_talent.vue?vue&type=script&lang=js"
export * from "./En_talent.vue?vue&type=script&lang=js"
import style0 from "./En_talent.vue?vue&type=style&index=0&id=53eb53fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb53fe",
  null
  
)

export default component.exports